import React from 'react'

type Props = {
  Content: React.ReactElement
}

export default function Slot({ Content }: Props) {
  return <>{Content}</>
}
